export const LanguagesInOttawa = [
  {
    heading: "French",
    detail:
      "As the first official spoken language, French is a very important one of Ottawa residents, spoken by more than 95,000 residents. Those with limited English proficiency but proficient in French may need translation services, either for personal or professional reasons. Reach out today. ",
    link: "/french-translation.php",
  },
  {
    heading: "Spanish",
    detail:
      "One of the most popular languages in Ottawa aside from English and French is Spanish. A global language, Spanish is key to communication with Ottawa residents and beyond. If you're looking at Spanish as your target language, not to worry. Tomedes is here.",
    link: "/spanish-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "A global language and spoken by many businesses around the world, Chinese is also spoken by 14,055 residents in Ottawa. It might be helpful to translate from English to Chinese, French to Chinese, or Chinese to any other language. There's many languages to choose from for your business or for yourself.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "Arabic",
    detail:
      "One of the most popular languages in Ottawa and spoken by 38,080 residents, Tomedes Arabic translators have the knowledge of both spoken and written Arabic, and can translate or interpret in this language. Need more? Just reach out.",
    link: "/arabic-translation.php",
  },
];
